export const SET_BUNDLE_FILTER_LIST = "SET_BUNDLE_FILTER_LIST";
export const SET_BUNDLE_LIST = "SET_BUNDLE_LIST";
export const SET_BUNDLE_REQUEST = "SET_BUNDLE_REQUEST";
export const SET_BUNDLE = "SET_BUNDLE";
